import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 17.5V6.5C6 6.22386 6.22386 6 6.5 6H17.5C17.7761 6 18 6.22386 18 6.5V17C18 17.5523 17.5523 18 17 18H6.5C6.22386 18 6 17.7761 6 17.5Z",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15.5L9.31401 11.2391C9.41046 11.1151 9.59604 11.1098 9.69949 11.228L12.824 14.7989C12.9193 14.9077 13.0867 14.9133 13.189 14.811L14.8386 13.1614C14.93 13.07 15.0761 13.0634 15.1754 13.1462L18 15.5",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.25,
			cy: 9.25,
			r: 1.25,
			fill: "black"
		})
	]
});
export default SvgImage;
